import { requestNavigation } from "./navigationStore.js";

export function openAgentPolicyPilot(agentId, releaseId) {
    if (!agentId || !releaseId) return;
    requestNavigation({ kind: "agent-policy-pilot", agentId, releaseId });
}

export function applyAgentPolicyPilotParams(params, { agentId, releaseId }) {
    params.set("mode", "governance");
    params.set("policyAgent", agentId);
    params.set("policyRelease", releaseId);
    for (const key of ["adminView", "settingsView", "view", "menu", "tab", "tabs", "scope", "active"]) params.delete(key);
}
